module.exports = __webpack_public_path__ + "static/media/water6.51fbaaa2.svg";